if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					// Store the original value when the input is focused
					qty.addEventListener('focus', (e) => {
						item.dataset.originalQty = e.target.value;
					});
					
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						const originalQty = parseInt(item.dataset.originalQty || 0);
						const newQty = parseInt(qty.value);
						this.updateCartQty(item, newQty, originalQty);
					}, 500));
					
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		async validateQuantity(item, newQty, originalQty) {
			const variantId = Number(item.querySelector('input[name="updates[]"]')?.value || item.dataset.variantId || 0);
			const parentProductSku = item.dataset.sku || '';

			if (window.cartCalculator?.calculateCart) {
				let result;
				if (newQty === 0) {
					// When removing an item, pass isRemove: true
					result = await window.cartCalculator.calculateCart({ 
						variantId, 
						parentProductSku, 
						qty: 0,
						isRemove: true
					});
				} else {
					// Normal quantity update
					result = await window.cartCalculator.calculateCart({ 
						variantId, 
						parentProductSku, 
						qty: newQty - originalQty // We're adding this many items
					});
				}
				
				if (!result.ok) {
					// Revert to original quantity if calculation fails
					item.querySelector('.qty').value = originalQty;
					return false;
				}
			}
			return true;
		}

		async updateCartQty(item, newQty, originalQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			// If originalQty is not provided, default to 0 (for removal)
			originalQty = originalQty || 0;
			const isValid = await this.validateQuantity(item, newQty, originalQty);
			if (!isValid) {
				this.form.classList.remove('processing');
				return;
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if (typeof CartProductQuantity !== 'function') {

	class CartProductQuantity extends HTMLElement {
		constructor() {
			super();

			this.querySelector('.qty-minus').addEventListener('click', (event) => {
				this.updateCartQuantity(event, 'minus');
			});

			this.querySelector('.qty-plus').addEventListener('click', (event) => {
				this.updateCartQuantity(event, 'plus');
			});
		}

		updateCartQuantity(event, action) {
			const button = event.currentTarget;
			const item = this.closest('[data-js-cart-item]');
			const input = this.querySelector('.qty');
			const currentQty = parseInt(input.value);
			
			// Calculate the original quantity based on the action
			const originalQty = action === 'plus' ? currentQty - 1 : currentQty + 1;
			
			// Store the original quantity as a data attribute for reference
			item.dataset.originalQty = originalQty;
			
			// Disable the button to prevent multiple clicks
			button.disabled = true;
			
			// Call updateCartQty and re-enable the button after a short delay
			document.getElementById('AjaxCartForm').updateCartQty(item, currentQty, originalQty);
			
			// Re-enable the button after a short delay
			setTimeout(() => {
				button.disabled = false;
			}, 500);
		}
	}

	if (typeof customElements.get('cart-product-quantity') === 'undefined') {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}
}




// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}
	window.updateCartCount = () => {
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
	
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
	
				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();
	
				// Update cart count and total in header
				document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
					const count = cartItems.querySelector('[data-cart-count]');
					if (count) elm.textContent = count.textContent;
				});
	
				document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
					const total = cartItems.querySelector('[data-cart-total]');
					if (total) elm.textContent = total.textContent;
				});
	
				// Update subtotal
				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
	
				// Remove cart drawer opening behavior
				// Removed: document.querySelector('[data-js-site-cart-sidebar]').show();
	
				// Refresh recommendations if present
				const recommendations = document.querySelector('cart-recommendations');
				if (recommendations) {
					recommendations.innerHTML = '';
					recommendations.generateRecommendations();
				}
			});
	}
	

}
